import { LE_PACK_SYM } from "./consts";
const createLifePack = creator => {
  const lp = {
    resolve: () => [].concat(creator())
  };
  Object.defineProperty(lp, LE_PACK_SYM, {
    value: true,
    configurable: false
  });
  return lp;
};
export default createLifePack;